import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IMeetingsJobDetails, IMeetingsRemovingJobResult } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';

const meetingsRemoveJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<
    IMeetingsJobDetails,
    IMeetingsRemovingJobResult
>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IMeetingsRemovingJobResult>) => {
        return <FormattedMessage
            id='oe.meetings.haveBeenRemoved'
            defaultMessage='{count} meetings have been removed'
            description='Remove meetings modal body'
            values={{
                count: props.result.removedMeetings
            }}
        />;
    },
    failedComponent: () => {
        return <FormattedMessage
            id='oe.meetings.removingFailed'
            defaultMessage='Meeting Removing Failed'
            description='Remove meetings modal body'
        />;
    }
};

export { meetingsRemoveJobProperties };
